/** @jsx jsx */

import { jsx } from '@emotion/core';
import { IconName, LegacyIconButton } from '@zapier/design-system';

type Props = {
  label: string;
  name: IconName;
  isDisabled?: boolean;
  onClick?: () => void;
};

const SidebarButton = (props: Props) => {
  const { isDisabled, label, name, onClick } = props;
  return (
    <LegacyIconButton
      aria-label={label}
      disabled={isDisabled || onClick === undefined || onClick === null}
      icon={name}
      onClick={onClick}
    />
  );
};

export default SidebarButton;
